module.exports = __webpack_public_path__ + "img/B4.936b64e0.png";